import { useMutation, useQuery } from '@tanstack/react-query';
import { NoteAPI, NoteSourceType } from 'api/note';
export const AllNotesBySourceKey = (source)=>[
        'notes',
        'by-source',
        source.sourceType,
        source.sourceId
    ];
export const useGetAllNotesBySource = (source, options = {})=>{
    return useQuery(AllNotesBySourceKey(source), ()=>NoteAPI.getAllNotesBySource(source), options);
};
export const useGetAllCompanyNotes = (source, options = {})=>{
    return useQuery(AllNotesBySourceKey(source), ()=>NoteAPI.getAllNotesBySource(source), options);
};
export const useGetAllProjectNotes = (source, options = {})=>{
    return useQuery(AllNotesBySourceKey(source), ()=>NoteAPI.getAllProjectNotes(source), options);
};
export const useCreateNoteMutation = (options = {})=>useMutation((payload)=>payload.associatedEntity.sourceType === NoteSourceType.Company ? NoteAPI.createNote(payload) : NoteAPI.createProjectNote(payload), options);
export const useUpdateNoteMutation = (options = {})=>{
    return useMutation((payload)=>{
        var _payload_note_sourceId;
        return payload.note.noteType === NoteSourceType.Company ? NoteAPI.updateNote(payload) : NoteAPI.updateProjectNote(payload, payload.note.noteType, (_payload_note_sourceId = payload.note.sourceId) !== null && _payload_note_sourceId !== void 0 ? _payload_note_sourceId : -1);
    }, options);
};
export const useDeleteNoteMutation = (options = {})=>{
    return useMutation(({ noteId, noteType, sourceId })=>noteType === NoteSourceType.Company ? NoteAPI.deleteNote(noteId) : NoteAPI.deleteProjectNote(noteId, noteType, sourceId !== null && sourceId !== void 0 ? sourceId : -1), options);
};
